<template>
  <div class="prolist">
    <div class="header">
      <img :src="info.avatarPath | getavatar" alt="" />
      <span v-if="info.employeeNumber">工号：{{info.employeeNumber!=''?info.employeeNumber:info.nickName}}</span>
    </div>
    <div class="block">
      <van-tabs
        v-model="active"
        :border="false"
        @click="getactive"
        color="#2295F4"
      >
        <!-- <van-tab title="标签 1"></van-tab> -->
        <van-tab
          v-for="(item, index) in typelist"
          :key="index"
          :title="item.name"
        >
        </van-tab>
      </van-tabs>
      <div class="ov1">
        <div class="btn_group">
          <button
            :class="{ checked: btnactive == index }"
            v-for="(item, index) in btnlist"
            :key="index"
            @click="setbtn(item, index)"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
      <produceCell
        :coursedata="proList"
        :loading="listLoading"
        :finished="listFinished"
        @footerRefresh="getcourse"
        @watchCourse="watchCourse"
      ></produceCell>
    </div>
    <Footer/>
  </div>
</template>
<script>
import produceCell from "../viewcomponents/produceCell";
import { productType, company, product, userinfo } from "@/api/apis";
import {setyoumeng} from '../../utils/index'
import Footer from "@/components/produceFooter";
export default {
  components: {
    produceCell,
    Footer
  },
  data() {
    return {
      active: 0,
      btnactive: 0,
      listLoading: false,
      listFinished: false,
      proList: [],
      page: 0,
      btnlist: [{ name: "全部", id: "" }],
      typelist: [{ name: "热销产品", id: "" }],
      productTypeId: "",
      companyId: "",
      info: "",
    };
  },
  methods: {
    watchCourse(index) {
      console.log(index);
      let url = "";
      if (this.proList[index].url.substr(-1) == "=") {
        url = this.proList[index].url  + this.info.employeeNumber;
      } else {
        url = this.proList[index].url
      }
      window.location.href = url;
    },
    getcourse() {
      let that = this;
      if (that.listFinished) {
        return;
      }
      const params = {
        enabled: true,
        page: this.page,
        size: 10,
        productTypeId: this.productTypeId,
        companyId: this.companyId,
        sort: ["isTop,desc",'zlxSort,asc'],
        // sort:'zlxSort,asc',
        type:'online'
      };
      if (that.listLoading) {
        return;
      }
      that.listLoading = true;
      product(params)
        .then((res) => {
          let totalElements = res.totalElements;
          that.proList = that.proList.concat(res.content);
          if (res.content.length == 0) {
            that.listFinished = true;
          } else {
            that.listFinished = false;
            this.page++;
          }
          that.listLoading = false;
        })
        .catch((res) => {
          that.listLoading = false;
        });
    },
    setbtn(item, index) {
      console.log();
      this.btnactive = index;
      this.companyId = item.id;
      this.page = 0;
      this.proList = [];
      this.listFinished = false;
      this.getcourse();
    },
    getactive(name, title) {
      // console.log(name,title)
      // this.name=title=='热销产品'?'':title
      this.productTypeId = this.typelist[name].id;
      this.page = 0;
      this.proList = [];
      this.listFinished = false;
      this.getcourse();
    },
    getcomany() {
      let data = {
        enabled: true,
        page: 0,
        size: 99,
        sort: "sort,asc",
      };
      company(data).then((res) => {
        this.btnlist = this.btnlist.concat(res.content);
      });
    },
    getype() {
      let data = {
        enabled: true,
        page: 0,
        size: 99,
        sort: "sort,asc",
      };
      productType(data).then((res) => {
        this.typelist = this.typelist.concat(res.content);
      });
    },
    getinfo() {
      userinfo().then((res) => {
        this.info = res;
        if (!this.$store.state.user.user.user) {
          this.$store.commit("SET_USER", { user: res });
        }
        console.log(res);
      });
    },
  },
  mounted() {
    setyoumeng('https://s4.cnzz.com/z_stat.php?id=1279766259&web_id=1279766259')
    this.getcourse();
    this.getcomany();
    this.getype();
    this.getinfo();
  },
  filters: {
    getavatar(val) {
      if (val && val.indexOf("http") == -1) {
        if (val.indexOf("/avatar/") == -1) {
          return process.env.VUE_APP_URL + "/avatar/" + val;
        } else {
          console.log(val.split("zlxadmin")[1]);
          return process.env.VUE_APP_URL + val.split("zlxadmin")[1];
        }
      } else {
        return val;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.prolist {
  width: 100%;
  padding-bottom: 80px;
  .header {
    width: 349px;
    height: 50px;
    border-radius: 6px;
    color: #101010;
    font-size: 14px;
    font-family: sans-serif;
    background: #fff;
    margin: 21px auto;
    display: flex;
    align-items: center;
    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      margin-left: 12px;
      margin-right: 12px;
    }
  }
  .block {
    width: 348px;
    // height: 639px;
    border-radius: 8px;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    background: #fff;
    margin: 0 auto;
    overflow: hidden;
    // padding:35px 23px ;
    .ov1 {
      width: 336px;
      height: 44px;
      overflow: hidden;
    }
    .btn_group {
      overflow-x: scroll;
      height: 56px;
      display: flex;
      margin: 16px 12px 0;
      box-sizing: border-box;
      button {
        min-width: 70px;
        height: 28px;
        line-height: 28px;
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 100);
        color: rgba(49, 73, 91, 100);
        font-size: 13px;
        text-align: center;
        font-family: Roboto;
        border: 1px solid rgba(237, 241, 245, 100);
        flex-shrink: 0;
        margin-right: 14px;
      }
      .checked {
        background-color: rgba(27, 140, 237, 100);
        color: rgba(246, 245, 245, 100);
      }
    }
  }
}
</style>